export default { 
        apiKey: "AIzaSyDcLxeD6rsyfhBjj7AkZQRPtDCod1liwAQ",
        authDomain: "covid19-6bbe9.firebaseapp.com",
        databaseURL: "https://covid19-6bbe9.firebaseio.com",
        projectId: "covid19-6bbe9",
        storageBucket: "covid19-6bbe9.appspot.com",
        messagingSenderId: "213662330426",
        appId: "1:213662330426:web:6a9c97fa2cd46ea19acf03",
        measurementId: "G-46PCPR8GEE"
}
